import { useTheme } from '@mui/styles'
import { Box, Button, FormControl, IconButton, Typography } from '@mui/material'
import { Launch, Link as LinkIcon, LinkOff } from '@mui/icons-material'
import { showFormModal } from 'state/ui'
import { getCustomerId } from 'components/containers/inbound-tickets/utils'
import FORM_MODALS, { FormModalPropsMap } from 'utils/ui/modals.ts'

const DispatchTicketFormArea = ({
  inboundTicketData,
  preparedPropIbtData,
  statusIsPaidOrVoided,
  disabled,
  dispatch,
  setShowUnlinkModal,
  materialTypesData,
  formData,
}) => {
  const theme = useTheme()

  if (!inboundTicketData?.linkedDispatchTicket) {
    return (
      <Box sx={{ flex: 1, display: 'flex' }}>
        <Button
          variant="outlined"
          sx={{ flex: 1, border: '1px solid #009F4D80', fontWeight: 'bold' }}
          disabled={disabled || statusIsPaidOrVoided()}
          startIcon={<LinkIcon />}
          onClick={() => {
            dispatch(
              showFormModal({
                formModalName: FORM_MODALS.CREATE_FROM_DISPATCH as keyof FormModalPropsMap,
                formModalProps: {
                  ticketId: preparedPropIbtData?.id,
                  billId: preparedPropIbtData?.billId,
                  ticketNumber: preparedPropIbtData?.ticketId,
                  customerId: getCustomerId(null, preparedPropIbtData, null, null),
                  inboundTicketData: preparedPropIbtData,
                  materialTypesData,
                  formData: formData,
                },
              }),
            )
          }}
        >
          Link Dispatch Ticket
        </Button>
      </Box>
    )
  } else {
    return (
      <Box sx={{ flex: 1, display: 'flex', alignItems: 'center' }}>
        <FormControl sx={{ flex: 1 }}>
          <Typography
            variant="body1"
            style={{
              // This manually matches the <InputLabel shrink/> styling
              position: 'absolute',
              top: 0,
              left: 0,
              fontSize: '0.75rem',
              color: theme.palette.text.secondary,
              lineHeight: '1.5',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              transform: 'translateY(-10px)',
            }}
          >
            Dispatch Ticket
          </Typography>
          <Typography
            variant="body1"
            style={{
              marginTop: '6px',
            }}
          >
            #{inboundTicketData.linkedDispatchTicket.externalId}
          </Typography>
        </FormControl>
        <IconButton sx={{ borderRadius: 1 }} onClick={() => setShowUnlinkModal(true)}>
          <LinkOff />
        </IconButton>
        <IconButton
          sx={{ borderRadius: 1 }}
          onClick={() => {
            window.open('/app/load-board/ticket-history/' + inboundTicketData.linkedDispatchTicket.id, '_blank')
          }}
        >
          <Launch />
        </IconButton>
      </Box>
    )
  }
}

export default DispatchTicketFormArea
